import { Component } from 'react';
import DateTime from 'react-datetime';
import { Col, Card, Row, FormGroup, Button } from 'react-bootstrap';

class PipEposSubmissionsReportDatePicker extends Component {
  render() {
    const {
      startDate,
      endDate,
      onHandleStartDateChange,
      onHandleEndDateChange,
      onHandleClear
    } = this.props;

    return (
      <Card className="submission-filter admin-search-filter">
        <Card.Body>
          <Row>
            <Col md={3}>
              <FormGroup>
                Start Date
                <DateTime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={startDate}
                  onChange={onHandleStartDateChange}
                  inputProps={
                    { placeholder: 'Start Date' }
                  }
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                End Date
                <DateTime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={endDate}
                  onChange={onHandleEndDateChange}
                  inputProps={
                    { placeholder: 'End Date' }
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="actions" style={{ marginTop: '20px' }}>
              <Button
                className="red-ghost-btn"
                onClick={onHandleClear}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export default PipEposSubmissionsReportDatePicker;
